import React from 'react';
interface PlaceholderProps {
  children: React.ReactNode;
}

/** Visually marks a value that still needs to be filled in, e.g. [verify label]. */
export function Placeholder({
  children
}: PlaceholderProps) {
  return <span className="mx-0.5 inline-block rounded border border-dashed border-[#10b981]/50 bg-[#10b981]/10 px-1.5 py-0.5 font-mono text-[0.82em] font-medium text-[#6ee7b7]" data-id="element-80" data-mp="3khot9za914m9">
      {children}
    </span>;
}
const LINK_PATTERN = /(\[[^\]]+\]\([^)\s]+\))/g;
const PLACEHOLDER_PATTERN = /(\[[^\]]+\])/g;
function InlineLink({
  label,
  href
}: {
  label: string;
  href: string;
}) {
  return <a href={href} target="_blank" rel="noreferrer noopener" className="font-semibold text-[#10b981] underline decoration-[#10b981]/40 decoration-2 underline-offset-4 transition-colors duration-200 hover:text-[#34d399] hover:decoration-[#34d399]" data-id="element-81" data-mp="31pw7aotlkjo1">
      {label}
    </a>;
}
function stylePlaceholders(text: string, keyPrefix: string): React.ReactNode[] {
  return text.split(PLACEHOLDER_PATTERN).map((part, index) => part.startsWith('[') && part.endsWith(']') ? <Placeholder key={`${keyPrefix}-p-${index}`} data-id="element-82" data-mp="2pzk7v725zlf8">{part}</Placeholder> : <React.Fragment key={`${keyPrefix}-t-${index}`} data-id="element-83" data-mp="2lxyqb8eoqiyp">{part}</React.Fragment>);
}

/**
 * Renders a string, turning [label](url) into a real link and styling any
 * remaining [bracketed placeholder] so it's obvious it still needs filling in.
 */
export function withPlaceholders(text: string): React.ReactNode[] {
  return text.split(LINK_PATTERN).flatMap((part, index) => {
    const link = /^\[([^\]]+)\]\(([^)\s]+)\)$/.exec(part);
    if (link) {
      return [<InlineLink key={`link-${index}`} label={link[1]} href={link[2]} data-id="element-84" data-mp="2285214b6ilz8" />];
    }
    return stylePlaceholders(part, `s${index}`);
  });
}